import { DOCUMENT } from '@angular/common';
import { Injectable, RendererFactory2, inject } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AbilityService } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { ModalService, ModalSettings, ToastService } from 'mbs-ui-kit';

@Injectable()
export class ModalWrapper extends ModalService {
  protected modalService: NgbModal;
  protected rendererFactory: RendererFactory2;
  protected document: Document;
  private i18n = inject(I18NextPipe);
  private ability = inject(AbilityService);
  private toastService = inject(ToastService);

  constructor() {
    const modalService = inject(NgbModal);
    const rendererFactory = inject(RendererFactory2);
    const document = inject<Document>(DOCUMENT);

    super();

    this.modalService = modalService;
    this.rendererFactory = rendererFactory;
    this.document = document;
  }

  protected openModal(content: any, options?: ModalSettings): NgbModalRef {
    if (options?.permissions?.length && options?.missingPermissionActionName) {
      const missingPermissions = options.permissions.filter((permission) => !this.ability.can('read', permission));
      if (missingPermissions.length) {
        const action = options?.missingPermissionActionName;
        const permissionsLabels = this.getPermissionsLabels(missingPermissions)
          .map((label) => `'${label}'`)
          .join(', ');

        this.toastService.error(
          this.i18n.transform('shared:modals.permissionRequiredText', { param: permissionsLabels, action }),
          this.i18n.transform('shared:modals.permissionRequiredTitle')
        );
        return null;
      }
    }

    return this.modalService.open(content, this.getOptions(options));
  }

  private getPermissionsLabels(permissions: string[]): string[] {
    return permissions.map((permission) => this.i18n.transform('shared:permissionsLabels.' + permission));
  }
}
